module.exports = "/images/icon_kbank.png?a3612b50f5201001b7206faa1b2e2c5c";